import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 84644CCB-31DB-471C-AF2C-6E8AD1DE94CA
 * name image-size-select-actual
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-size-select-actual.svg
 * tags
 */
export const ImageSizeSelectActualIcon = createSvgIcon(<><path d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z" /></>, 'ImageSizeSelectActualIcon');
export default ImageSizeSelectActualIcon